import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Button from 'shopper/components/Button';
import Heading from 'shopper/components/Heading';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

const CarouselHeading = ({
  className,
  subtitle,
  showArrows,
  title,
  onScrollLeft,
  onScrollRight,
}) => (
  <div
    className={twMerge(
      'flex items-center justify-between px-2 py-4',
      className
    )}
  >
    <div className="mb-4 flex flex-col gap-2">
      <Heading className="text-neutral-high-100" size="size4">
        {title}
      </Heading>
      <Text className="text-neutral-high-100">{subtitle}</Text>
    </div>
    {showArrows && (
      <div className="hidden gap-3 lg:flex">
        <Button
          className="border-neutral-high-100 [&>svg]:text-neutral-high-100"
          icon={<Icon name="arrow-left-narrow" />}
          size="size3"
          type="neutral-ghost"
          onClick={onScrollLeft}
        />
        <Button
          className="border-neutral-high-100 [&>svg]:text-neutral-high-100"
          icon={<Icon name="arrow-right-narrow" />}
          size="size3"
          type="neutral-ghost"
          onClick={onScrollRight}
        />
      </div>
    )}
  </div>
);

CarouselHeading.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  showArrows: PropTypes.bool.isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  onScrollLeft: PropTypes.func.isRequired,
  onScrollRight: PropTypes.func.isRequired,
};

export default CarouselHeading;
